/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Provider-neutral payment and merchant-of-record disclosure for the quote.
 * @export
 * @interface FlightCheckoutDisclosure
 */
export interface FlightCheckoutDisclosure {
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutDisclosure
     */
    consentVersion: string;
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutDisclosure
     */
    merchantOfRecord: FlightCheckoutDisclosureMerchantOfRecordEnum;
    /**
     *
     * @type {string}
     * @memberof FlightCheckoutDisclosure
     */
    paymentInstrument: FlightCheckoutDisclosurePaymentInstrumentEnum;
    /**
     *
     * @type {boolean}
     * @memberof FlightCheckoutDisclosure
     */
    loyaltyBenefitsNotGuaranteed: boolean;
}


/**
 * @export
 */
export const FlightCheckoutDisclosureMerchantOfRecordEnum = {
    Airline: 'airline',
    Supplier: 'supplier',
    Unknown: 'unknown'
} as const;
export type FlightCheckoutDisclosureMerchantOfRecordEnum = typeof FlightCheckoutDisclosureMerchantOfRecordEnum[keyof typeof FlightCheckoutDisclosureMerchantOfRecordEnum];

/**
 * @export
 */
export const FlightCheckoutDisclosurePaymentInstrumentEnum = {
    CustomerCard: 'customer_card',
    SupplierBalance: 'supplier_balance',
    Unknown: 'unknown'
} as const;
export type FlightCheckoutDisclosurePaymentInstrumentEnum = typeof FlightCheckoutDisclosurePaymentInstrumentEnum[keyof typeof FlightCheckoutDisclosurePaymentInstrumentEnum];


/**
 * Check if a given object implements the FlightCheckoutDisclosure interface.
 */
export function instanceOfFlightCheckoutDisclosure(value: object): value is FlightCheckoutDisclosure {
    if (!('consentVersion' in value) || value['consentVersion'] === undefined) return false;
    if (!('merchantOfRecord' in value) || value['merchantOfRecord'] === undefined) return false;
    if (!('paymentInstrument' in value) || value['paymentInstrument'] === undefined) return false;
    if (!('loyaltyBenefitsNotGuaranteed' in value) || value['loyaltyBenefitsNotGuaranteed'] === undefined) return false;
    return true;
}

export function FlightCheckoutDisclosureFromJSON(json: any): FlightCheckoutDisclosure {
    return FlightCheckoutDisclosureFromJSONTyped(json, false);
}

export function FlightCheckoutDisclosureFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightCheckoutDisclosure {
    if (json == null) {
        return json;
    }
    return {

        'consentVersion': json['consent_version'],
        'merchantOfRecord': json['merchant_of_record'],
        'paymentInstrument': json['payment_instrument'],
        'loyaltyBenefitsNotGuaranteed': json['loyalty_benefits_not_guaranteed'],
    };
}

export function FlightCheckoutDisclosureToJSON(json: any): FlightCheckoutDisclosure {
    return FlightCheckoutDisclosureToJSONTyped(json, false);
}

export function FlightCheckoutDisclosureToJSONTyped(value?: FlightCheckoutDisclosure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'consent_version': value['consentVersion'],
        'merchant_of_record': value['merchantOfRecord'],
        'payment_instrument': value['paymentInstrument'],
        'loyalty_benefits_not_guaranteed': value['loyaltyBenefitsNotGuaranteed'],
    };
}
